<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'unitsCrud'"
          crudName="Unidades"
          newText="Nova Unidade"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="canManageUnits"
          :enableEdit="canManageUnits"
          :enableDelete="canManageUnits"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "unitsTable",
      unitsCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "company_id",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "name",
        "company_id",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "company_id", "status"],
        sortable: ["id", "name", "company_id", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        orderBy: { column: "id", ascending: true },
        headings: {
          id: "ID",
          name: "Nome da Unidade",
          company_id: "Empresa",
          status: "Status",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: "1",
              text: "Ativo",
            },
            {
              id: "0",
              text: "Inativo",
            },
          ],
        },
        templates: {
          company_id: function (h, row, index) {
            if (row.company && row.company.name) {
              return row.company.name;
            }
            return (
              <span style="color: #999;">Sem empresa</span>
            );
          },
          status: function (h, row, index) {
            if (row.status === "1" || row.status === 1) {
              return (
                <h5>
                  <span class="badge badge-primary">Ativo</span>
                </h5>
              );
            } else if (row.status === "0" || row.status === 0) {
              return (
                <h5>
                  <span class="badge badge-danger">Inativo</span>
                </h5>
              );
            }

            return (
              <h5>
                <span class="badge badge-secondary">Desconhecido</span>
              </h5>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "units",
      dataForm: {},
    };
  },

  mounted() {
    const loggedUser = this.$store.state.auth?.user || this.$store.state.user || null;

    if (Number(loggedUser?.perfil_id) === 2) {
      this.$message("Erro", "Você não tem permissão para acessar esta tela", "error");
      this.$router.push("/");
      return;
    }
  },

  components: {
    BaseCrud,
  },

  computed: {
    // Gestor Operacional (perfil 7) tem acesso somente leitura às unidades
    canManageUnits() {
      const loggedUser = this.$store.state.auth?.user || this.$store.state.user || null;
      return Number(loggedUser?.perfil_id) !== 7;
    },
  },

  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        company_id: "company_id",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>